import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  // 云闪付首页专题数据
  indexSubjectInfo: {},
  // H5商城首页资源位数据
  indexResourceInfo: {
    loaded: false
  },
  // H5商城开屏广告数据
  indexOpenAdList: [],
  // 商家端首页资源位数据
  retailResourceInfo: {
    loaded: false
  },
};

export default function home(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.GET_YSF_INDEX_INFO:
      result.indexSubjectInfo = payload;
      break;
    // 获取H5商城首页数据
    case ACTION_TYPES.GET_INDEX_RESOURCE_INFO:
      result.indexResourceInfo = {
        ...payload,
        loaded: true,
      };
      break;
    // 获取H5商城开屏广告数据
    case ACTION_TYPES.GET_INDEX_OPEN_AD_LIST:
      result.indexOpenAdList = payload;
      break;
    // 商家端首页数据
    case ACTION_TYPES.GET_RETAIL_RESOURCE_INFO:
      result.retailResourceInfo = {
        ...payload,
        loaded: true,
      };
      break;
    default:
      result = state;
  }
  return result;
}
